import { useState } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ModalControlModalProps } from '@frontend/design-system';
import { MonthProduction } from '../morning-huddle/month-production';
import { ProductionTypes, type ProductionSummary } from '../morning-huddle/production-types';
import { ScheduledProduction } from '../morning-huddle/scheduled-production';
import { MorningHuddleSettingsModal } from '../morning-huddle/settings-modal';
import { SummaryStats } from '../morning-huddle/summary-stats';

type Props = {
  reportDate: string;
  settingModalProps: ModalControlModalProps;
};

export const MorningHuddleTabPanel = ({ reportDate, settingModalProps }: Props) => {
  const [summaryStats, setSummaryStats] = useState<ProductionSummary | undefined>();
  const [isLoadingSummaryStats, setIsLoadingSummaryStats] = useState<boolean | undefined>();

  return (
    <>
      <div css={styles.contentWrapper}>
        <div css={styles.monthProductionWrapper}>
          <MonthProduction reportDate={reportDate} />
          <SummaryStats isLoading={isLoadingSummaryStats} summaryStats={summaryStats} />
        </div>
        <ProductionTypes
          onLoadData={setSummaryStats}
          onLoadingStatusChange={setIsLoadingSummaryStats}
          reportDate={reportDate}
        />
        <ScheduledProduction reportDate={reportDate} />
      </div>
      <MorningHuddleSettingsModal {...settingModalProps} />
    </>
  );
};

const styles = {
  contentWrapper: css`
    width: 100%;
  `,

  monthProductionWrapper: css`
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(3)};
  `,
};
